// src/components/ui/RatingStars.jsx
import React from 'react';
import Star from './Star';

const RatingStars = ({ value = 0, count, size = 14 }) => {
  const hasValue = Number.isFinite(value) && value > 0;
  const hasCount = Number.isFinite(count) && count > 0;

  const safeVal = hasValue ? Number(value) : 0;
  const fullStars = Math.floor(safeVal);
  const hasHalf = safeVal - fullStars >= 0.5;

  return (
    <div className="inline-flex items-center gap-1 sm:gap-1.5 whitespace-nowrap">
      <div className="inline-flex items-center gap-px">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            filled={i < fullStars}
            half={i === fullStars && hasHalf}
            size={size}
          />
        ))}
      </div>

      {hasValue && (
        <span className="inline-flex items-center gap-1 text-xs text-gray-600 leading-none">
          <span className="font-medium text-black">{safeVal.toFixed(1)}</span>
          {hasCount && <span className="text-gray-400">({count})</span>}
        </span>
      )}
    </div>
  );
};

export default RatingStars;